import { render, staticRenderFns } from "./AppointmentNextDay.vue?vue&type=template&id=52af980e&"
import script from "./AppointmentNextDay.vue?vue&type=script&lang=js&"
export * from "./AppointmentNextDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports